module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_16 (23).d85f2ee.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_16 (23).mp4
// module id = 798
// module chunks = 1